import { HttpClient } from '@angular/common/http';
import { BadgeList } from '@app/shared/const';
import { ResponseObject } from '@app/shared/models/response-object';
import { environment } from '@env/environment';
import { Observable, catchError, map, retry, timeout } from 'rxjs';
import { FanpageList } from './api.fanpage-management.model';

export class FanpageManagementApi {
  apiUrl = environment.API_URL;
  constructor(public readonly http: HttpClient) {}

  // mock data
  getFanpages(
    pageNum: number,
    pageSize: number,
    keySearch?: string,
    filterData?: any
  ): Observable<FanpageList> {
    let url = `${this.apiUrl}/page/management/search?pageNum=${pageNum}&pageSize=${pageSize}`;
    if (keySearch) {
      url += `&textSearch=${keySearch}`;
    }
    if (filterData && filterData.selectedStatuses && filterData.selectedStatuses.length) {
      const parsedString = filterData.selectedStatuses?.join('|');
      const encodedStatusString = encodeURIComponent(parsedString);
      url = url + `&status=${encodedStatusString}`;
    }
    if (filterData && filterData.isVerified) {
      url = url + `&isVerified=${filterData.isVerified}`;
    }
    if (
      filterData &&
      filterData.pageBadge &&
      filterData.pageBadge.length &&
      filterData.pageBadge.length < BadgeList.length
    ) {
      url = url + `&pageBadge=${filterData.pageBadge}`;
    }

    return this.http.get<ResponseObject>(url).pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  getSummaryInfoFanpage(): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.apiUrl}/page/management`).pipe(
      retry(1),
      map((res: any) => {
        return res.data;
      }),
      catchError(error => {
        throw error.error;
      })
    );
  }

  putActionFanpage(fanpageId: string, body: any): Observable<ResponseObject> {
    return this.http
      .put<ResponseObject>(`${this.apiUrl}/page/management/${fanpageId}/status`, body)
      .pipe(
        retry(1),
        map((res: any) => {
          return res.data;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  verifyPage(body: { id: string; isVerify: string }): Observable<ResponseObject> {
    return this.http
      .put<ResponseObject>(
        `${this.apiUrl}/page/management/page/${body.id}/verify-blue-tick?isVerifiedPage=${body.isVerify}`,
        {}
      )
      .pipe(
        retry(1),
        map((res: any) => {
          return res.data;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  updatePageBadge(pageId: string, badge: string, isUpdate: boolean, body: any): Observable<any> {
    return this.http
      .put<any>(
        `${this.apiUrl}/page/management/page/${pageId}/brands?brandsOnSoctrip=${badge}&isUpdate=${isUpdate}`,
        body
      )
      .pipe(
        timeout(10000),
        map(res => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }

  deletePageBadge(pageId: string, badge: string, body: any): Observable<any> {    
    return this.http
      .delete<any>(
        `${this.apiUrl}/page/management/page/${pageId}/brands?brandsOnSoctrip=${badge}`,
        { body }
      )
      .pipe(
        timeout(10000),
        map(res => {
          return res;
        }),
        catchError(error => {
          throw error.error;
        })
      );
  }
}
